// ducks/index.ts
import { combineReducers } from '@reduxjs/toolkit';
import cartReducer from './app';
import compareReducer from "./compare";
const rootReducer = combineReducers({
  store: cartReducer,
   compare: compareReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
